import { App } from '@capacitor/app';
import { faHome } from '@fortawesome/pro-solid-svg-icons';
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DEVICE } from '../../../config';

const isCapacitor = ['ANDROID', 'IOS'].includes(DEVICE);

const CapacitorBreadcrumb = isCapacitor ? ({ history = [] }) => {
  const computedHistory = [{ icon: faHome, title: null, action: '/', isRoot: true, }, ...history];
  const previous = computedHistory[computedHistory.length - 2] || null;
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const handleEvent = () => {
      console.log('📱 Back button pressed');
      if (previous) {
        if (typeof previous?.action === 'string') {
          navigate(previous?.action);
        } else if (typeof previous?.action === 'function') {
          previous?.action();
        }
      } else {
        App.exitApp();
      }
    };

    window.addEventListener('capacitor:app:backButton', handleEvent);
    return () => window.removeEventListener('capacitor:app:backButton', handleEvent);
  }, [previous, navigate]);
} : () => null;

export default CapacitorBreadcrumb;
